import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  About,
  Banner,
  Brand,
  Event,
  Home,
  Letter,
  NotFound,
  Partner,
  Policy,
  Post,
  Product,
  Login,
  Register,
  Reset,
  Forgot,
  Saves,
  Series,
  Settings,
  OrderList,
  OrderDetail,
  OrderInvoice,
  OrderOffer,
  OrderTax,
  OrderRefund,
  Checkout,
  CheckoutSuccess,
  CheckoutFail,
  Offer,
  Cart,
  Wish,
  User,
  Write,
  Success,
  Search,
  Estimate,
  EstimateBox,
  ShippingTracking,
  Deposit,
} from 'pages';
import EmailLogin from 'containers/etc/EmailLogin';
import Core from 'containers/base/Core';
import Callback from 'containers/etc/Callback';
import SSOCallback from 'containers/etc/SSOCallback';
import EmailCertifyContainer from 'containers/etc/EmailCertifyContainer';
import CustomError from 'pages/errors/CustomError';
import PrivateRoute from './privateRoute/PrivateRoute';

const App = () => (
  <React.Fragment>
    <Core />
    <Switch>
      <Route exact path="/" component={Home} />
      <Route
        path="/:mode(posts|products|banners|brands|events|letters|tags|categories|sections)"
        component={Home}
      />
      <PrivateRoute path="/login" component={Login} />
      <PrivateRoute path="/register" component={Register} />
      <Route path="/forgot" component={Forgot} />
      <Route path="/reset" component={Reset} />
      <Route path="/error" component={CustomError} />
      <Route path="/success" component={Success} />
      <Route path="/email-login" component={EmailLogin} />
      <PrivateRoute path="/write" component={Write} />
      <Route path="/cart" component={Cart} />
      <Route path="/wish" component={Wish} />
      <Route exact path="/orders" component={OrderList} />
      <Route exact path="/orders/:orderId" component={OrderDetail} />
      <Route exact path="/orders/:orderId/shipping-tracking/:fulfillmentId" component={ShippingTracking} />
      <Route exact path="/orders/:orderId/invoice" component={OrderInvoice} />
      <Route exact path="/orders/:orderId/offer" component={OrderOffer} />
      <Route exact path="/orders/:orderId/tax" component={OrderTax} />
      <Route exact path="/orders/:orderId/refund" component={OrderRefund} />
      <Route path="/checkout" component={Checkout} />
      <Route path="/checkout-success" component={CheckoutSuccess} />
      <Route path="/checkout-fail" component={CheckoutFail} />
      <Route path="/offer" component={Offer} />
      <Route exact path="/@:username/" component={User} />
      <Route exact path="/@:username/tags/:tag" component={User} />
      <Route exact path="/@:username/series/:urlSlug" component={Series} />
      <Route exact path="/@:username/products/:urlSlug" component={Product} />
      <PrivateRoute path="/@:username/:tab(like|history|about|series|products)" component={User} />
      <Route path="/@:username/banners/:urlSlug" component={Banner} />
      <Route path="/@:username/brands/:urlSlug" component={Brand} />
      <Route path="/@:username/events/:urlSlug" component={Event} />
      <Route path="/@:username/letters/:urlSlug" component={Letter} />
      {/* <Route path="/@:username/partners/:urlSlug" component={Partner} /> */}
      <Route path="/@:username/:urlSlug" component={Post} />
      <PrivateRoute path="/saves" component={Saves} />
      <PrivateRoute exact path="/deposit" component={Deposit} />
      <PrivateRoute exact path="/settings" component={Settings} />
      <PrivateRoute path="/settings/:tab(password|email)" component={Settings} />
      <Route path="/policy/:mode(policy|terms)?" component={Policy} />
      <Route path="/about" component={About} />
      <Route path="/callback" component={Callback} />
      <Route path="/auth/callback" component={SSOCallback} />
      <Route path="/certify" component={EmailCertifyContainer} />
      <Route path="/search" component={Search} />
      <Route component={NotFound} />
    </Switch>
  </React.Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js